export const TabNavigationType = {
  SAME: 'same',
  NEW: 'new',
  INTERNAL_SAME_EXTERNAL_NEW: 'internal-same-external-new',
} as const;

export type TabNavigationType = (typeof TabNavigationType)[keyof typeof TabNavigationType];
